// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'
import {Link} from 'react-router-dom'

// Components, services, etc
import Address from 'components/Address'
import Card from 'components/Card'
import Chip from 'components/Chip'
import Image from 'components/Image'
import {convertFromJSDateToFormattedDate} from 'services/datetime'
import {NormalizedAddress} from 'services/dataMutations'

import {productDataDictionary} from 'constants/productCardConstants'
import type {ProductType} from 'types/orderTypes'

type Props = {
  address: NormalizedAddress
  imageSrc?: string
  onClick: React.MouseEventHandler<HTMLDivElement>
  orderedDate?: string
  productType: ProductType
  to?: string | null
}

const OrderCard = ({address, imageSrc, productType, orderedDate, onClick, to}: Props) => {
  return (
    <OrderCard.Styled
      as={!to ? 'div' : Link}
      to={to as string} // seems null is not supported
      className='order-card'
      onClick={onClick}
    >
      <Card>
        <Image asImg src={imageSrc} height='115px' width='308px' />
        <div className='content'>
          <Address address={address} twoLines />
          <div className='bottom-row'>
            <Chip
              color={productDataDictionary[productType].productColor}
              label={productDataDictionary[productType].chipLabel}
            />
            <span className='ordered-date'>
              Ordered {convertFromJSDateToFormattedDate(orderedDate, 'MMM DD, YYYY')}
            </span>
          </div>
        </div>
      </Card>
    </OrderCard.Styled>
  )
}

OrderCard.defaultProps = {
  onClick: () => {}
}

OrderCard.Styled = styled(Link)`
  height: 236px;
  width: 308px;
  cursor: ${({to}) => (to ? 'pointer' : 'default')};
  text-decoration: none;

  .card {
    height: 100%;
    width: 100%;
    padding: 0;
    overflow: hidden;

    .content {
      padding: 20px;

      .address {
        .street {
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          /* truncate text with the following */
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          /* account for display block and the <br /> in Address, margin-bottom same as line-height */
          margin-bottom: -20px;
        }
        .city-state-zip {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .bottom-row {
        margin-top: 14px;

        .ordered-date {
          font-size: 12px;
          line-height: 17px;
          color: ${({theme}) => theme.colors.grayscale.gray};
          margin-left: 8px;
        }
      }
    }
  }
`

export default OrderCard
